import * as d3 from 'd3'

export default {
  methods: {

    draw_Summary(selection, _data, hoverData = null){

      let summ = this.summary

      // For moving summary box; re-calc primaryAxis and secondaryAxis
      this.set_maxValue(_data)

      let latest = hoverData ? hoverData : _data.find(f => f.CDATE == this.timeline.cutoff.date)
      if(!latest) return // 데이터가 없으면 에러 방지용으로 리턴

      let sx = summ.x
      let sy = summ.y + summ.box.height/2
      let tipPath = 'right'
      let value = 0

      if(summ.position.auto == 'Y') {
        let targetStyle = this.chart.styles.find(f => f.code == summ.position.code)
        let isBar = (targetStyle && targetStyle.type == 'BAR')

        let yAxisScale = isBar ? this.primary.axis : this.secondary.axis

        let scaledValue = yAxisScale(latest[summ.position.code])

        value = isBar ? (this.chart.height - scaledValue) : scaledValue
        sx = latest.mx
        sy = value 
        let percent = ((this.chart.height - value)/this.chart.height)*100
        if(percent < summ.position.top) tipPath = 'top'
        if(percent > summ.position.bottom) tipPath = 'bottom'
      }

      selection.selectAll('.gmx-summary-box').remove()

      let info = selection
      .append('g')
      .attr('class', 'gmx-summary-box')
      .attr('transform', `translate(${sx}, ${sy})`)

      info
      .append('path')
      .attr('d', this.gmx_TooltipPath(tipPath, summ.box.width, summ.box.height, summ.position.auto == 'Y' ? 5 : 0, summ.box.radius))
      .attr('fill', summ.fill.delta != 'Y' ? summ.fill.color : this.gmx_deltaValue(latest[summ.fill.code]))
      .attr('fill-opacity', summ.box.opacity)
      .attr('stroke', summ.box.stroke).attr('stroke-width', .5)

      this.draw_SummaryItem(info, latest, tipPath)
      
    },


    draw_SummaryItem(selection, latest, tipPath) {

      let summ = this.summary

      let sx = -5
      let sy = 5 - (summ.box.height/2)

      if(summ.position.auto == 'Y') {
        switch(tipPath) {
          case 'top':
            sx = sx - summ.box.width/2
            sy = - summ.box.height
          break

          case 'right':
            sx = 0
          break

          case 'bottom':
            sx = sx - summ.box.width/2
            sy = 10
          break
        }
      }

      let contents = selection
      .append('g')
      .attr('transform', `translate(${sx}, ${sy})`)

      let y = 5

      // Horizontal
      if(summ.dir.type == 'HOR') {
        
        summ.cols.filter(f=> f.code).forEach((d,i)=> {
          contents
          .append('text')
          .attr('x', summ.dir.x[i].mx).attr('y', y + d.tSize*0.36)
          .attr('text-anchor', 'middle')
          .attr('fill', summ.head.tColor).attr('font-size', summ.head.tSize)
          .text(d.name)

          if(d.name=='Delta') {
            contents
            .append('text')
            .attr('x', summ.dir.x[i].mx).attr('y', summ.lineHeight + d.tSize*0.36)
            .attr('fill', this.gmx_deltaValue(latest[d.code])).attr('font-size', d.tSize)
            .attr('text-anchor', 'middle')
            .text((typeof latest[d.code] === 'number' ? latest[d.code].toFixed(d.round) : latest[d.code]) + (d.unit || ''))
          } else {
            contents
            .append('text')
            .attr('x', summ.dir.x[i].mx).attr('y', summ.lineHeight + d.tSize*0.36)
            .attr('fill', d.tColor).attr('font-size', d.tSize)
            .attr('text-anchor', 'middle')
            .text((typeof latest[d.code] === 'number' ? latest[d.code].toFixed(d.round) : latest[d.code]) + (d.unit || ''))
            .call(this.event_Link, latest, d)
          }
        })
      }

      // Vertical
      if(summ.dir.type == 'VER') {
        summ.cols.forEach(d=> {
          contents
          .append('text')
          .attr('x', summ.dir.x[0].sx).attr('y', y + d.tSize*0.36)
          .attr('fill', summ.head.tColor).attr('font-size', summ.head.tSize)
          .text(d.name)

          if(d.name=='Delta') {
            contents
            .append('text')
            .attr('x', summ.dir.x[1].sx).attr('y', y + d.tSize*0.36)
            .attr('fill', this.gmx_deltaValue(latest[d.code])).attr('font-size', d.tSize)
            .text((typeof latest[d.code] === 'number' ? latest[d.code].toFixed(d.round) : latest[d.code]) + (d.unit || ''))
          } else {
            contents
            .append('text')
            .attr('x', summ.dir.x[1].sx).attr('y', y + d.tSize*0.36)
            .attr('fill', d.tColor).attr('font-size', d.tSize)
            .text((typeof latest[d.code] === 'number' ? latest[d.code].toFixed(d.round) : latest[d.code]) + (d.unit || ''))
            .call(this.event_Link, latest, d)
          }
          y += summ.lineHeight
        })
      }

      // Table
      if(summ.dir.type == 'TBL') {

        summ.dir.head.forEach((d,i)=> {
          contents
          .append('text')
          .attr('x', summ.dir.x[i].ex).attr('y', y + 10*0.36)
          .attr('fill', summ.head.tColor).attr('font-size', summ.head.tSize)
          .attr('text-anchor', i==0 ? 'start' : 'end')
          .text(d)
        })
        y += summ.lineHeight

        summ.dir.item.forEach(item=> {

          summ.cols.filter(f=> f.group == item).forEach((col,c)=> {
            // contents
            // .append('text')
            // .attr('x', summ.dir.x[c].ex).attr('y', y + col.tSize*0.36)
            // .attr('fill', summ.head.tColor).attr('font-size', summ.head.tSize)
            // .text(col.name)

            if(col.name=='Delta') {
              contents
              .append('text')
              .attr('x', summ.dir.x[c].ex).attr('y', y + col.tSize*0.36)
              .attr('fill', this.gmx_deltaValue(latest[col.code])).attr('font-size', col.tSize)
              .attr('text-anchor', c==0 ? 'start' : 'end')
              .text((typeof latest[col.code] === 'number' ? latest[col.code].toFixed(col.round) : latest[col.code]) + (col.unit || ''))
            } else {
              contents
              .append('text')
              .attr('x', col.code ? summ.dir.x[c].ex : summ.dir.x[c].sx).attr('y', y + col.tSize*0.36)
              .attr('fill', col.tColor).attr('font-size', col.tSize)
              .attr('text-anchor', c==0 ? 'start' : 'end')
              .text(col.code ? (typeof latest[col.code] === 'number' ? latest[col.code].toFixed(col.round) : latest[col.code]) + (col.unit || '') : item)
              .call(this.event_Link, latest, col)
            }
          })

          y += summ.lineHeight
        })

      }


    },

  }
}